export function getStatusComment(status){
    return status?.action_comment || "No comments available"
}
export function getLatestStatus(item) {
    if (!item || !Array.isArray(item.screening_status)) {
        return null;
    }
    return item.screening_status[item.screening_status.length - 1] || null;
}
export function getHighlightClass(status) {
    if (status === "completed") {
        return "highlight-green";
    }
    return "highlight-orange";
}
export function getHighlightStyle(status) {
    let colorData = ''
    if(status?.status){
        colorData = this.statusColors[status.status];
    }

    return { backgroundColor: (colorData && colorData.color) || "#FFFFFF" };
}
export function isRevertToApplicant(status) {
    return status?.status === "revertToApplicant";
}
export function getStatusValue(status,) {
    let colorData = '';

    if (status?.status) {
        colorData = this.statusColors[status.status];
    }

    return colorData ? colorData.value : status?.status;
}